<template>  
    <split-pane  :min-percent='0' :default-percent='defpct' split="vertical" style="background:white; height:100%">
        <template slot="paneL" v-if="btnBool" >
            <div style="min-width:230px;line-height:30px;padding-bottom:2px; padding-top:2px;padding-left:2px;display:flex">
                <div style="font-size:12px;width:30px; ">类别</div> 
                <el-select  multiple @change="matChg" clearable size="small" v-model="txtArr1" collapse-tags style="width:160px; height:30px; ">
                    <el-option v-for="(item,index) in tyArr" :key="index" :label="item.MATTYNM" :value="item.MATTYNM" ></el-option>
                </el-select>
                <el-checkbox label="显示隐藏" class="large-checkbox" size="mini" true-label="Y" false-label="N" v-model="v_hide" @change="qryBomData('')" style="margin-left:10px;color:red;font-size:12px;line-height:30px;margin-top:0px"></el-checkbox>
            </div>
            <el-table  :data="bomData" 
                border                            
                disabled-hover
                class="custom-table-border"
                :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                style="overflow:auto;margin-top:1px;"
                size="small"
                header-cell-class-name="clearPadding"
                v-loading="r_loading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)"
                @row-click="pMatClick"
                :height="matHeight" 
                ref="refbom" 
                highlight-current-row>
                <el-table-column label="序号" type="index" width="55" fixed>
                    <el-table-column label="序号" type="index" width="55" fixed>
                        <template slot="header"  >
                            <el-link   @click="clearRow" style="font-size:12px;color:#404eff;text-align:center"> 
                                <el-tooltip content=" 清除条件" effect="light">
                                    <i class="iconfont icon-shanchu1"  ></i>
                                </el-tooltip>
                            </el-link>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column v-for="(item ,index) in bomArr.filter(item=>item.thide=='N')" :key="index"  
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                          
                    :sortable="item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <el-table-column  resizable :prop="item.key" :align="item.align" :label="item.title" show-overflow-tooltip :min-width="item.width">
                        <template slot="header" slot-scope="scope">
                            {{scope.row}}
                            <el-select v-if="item.key=='MBTY'" @change="qryBomData('')" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                <el-option label="量产" value="A"  ></el-option>
                                <el-option label="成型未量产" value="B"  ></el-option>
                                <el-option label="草稿" value="C"  ></el-option>
                            </el-select>
                            <el-select v-else-if="item.key=='STFG'" @change="qryBomData('')" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                                <el-option label="已审" value="Y"  ></el-option>
                                <el-option label="未审" value="N"  ></el-option>
                            </el-select>
                            <el-date-picker v-else-if="item.edcss=='date'" @change="qryBomData('')" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                            <el-input type="number" placeholder="数字框"  @keyup.enter.native="qryBomData('')" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                            <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="qryBomData('')"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                        </template>
                        <template slot-scope="scope">
                            <el-tag  v-if="item.key=='MBTY'&&scope.row['MBTY']=='A'" size="mini" type="success" effect="dark">量产</el-tag>
                            <el-tag  v-else-if="item.key=='MBTY'&&scope.row['MBTY']=='B'" size="mini" type="danger" effect="dark">成型未量产</el-tag>                         
                            <el-tag  v-else-if="item.key=='MBTY'&&scope.row['MBTY']=='C'" size="mini" type="info" effect="dark">草稿</el-tag>  
                            <el-tag v-else-if="item.edcss=='checkbox' && scope.row[item.key]=='Y'" type="success" size="mini" effect="dark" style="text-align:center"> 是</el-tag> 
                            <el-tag v-else-if="item.edcss=='checkbox' && scope.row[item.key]!=='Y'" type="info" size="mini" effect="dark" style="text-align:center"> 否</el-tag> 
                            <span v-else v-text="scope.row[item.key]" ></span>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-link   @click="cpRec(scope.row )" :underline="false" ><span style="font-size:12px;border-bottom:1px solid red;margin-right:8px ">复制</span></el-link>
                        <span v-if="scope.row['STFG']=='Y'">
                            <!-- <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i> -->
                            <el-link   @click="stfgRec(scope.row,'N')" :underline="false"  ><span style="font-size:12px;border-bottom:1px solid red; ">弃审 </span></el-link>
                        </span>
                        <span v-if="scope.row['STFG']=='N'">
                            <!-- <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i> -->
                            <el-link   @click="stfgRec(scope.row,'Y')" :underline="false"  ><span style="font-size:12px;border-bottom:1px solid green; ">审核</span></el-link>
                        </span>
                    </template>
                </el-table-column>               
            </el-table> 
            <div style="padding-left:5px;overflow: hidden;display:flex;line-height:30px;height:34px;background:white;font-size:12px;margin-top:5px">
                <div style="float: left;">
                    <Page :total="prdCount" :page-size="rowSize" show-total :current="v_current" @on-change="changePrd"></Page>
                </div>
            </div> 
        </template>      
        <template slot="paneR">
            <split-pane  :min-percent='21' :default-percent='21' split="vertical">
                <template slot="paneL">
                    <div style="border-bottom:1px solid #ccc;line-height:35px;height:35px;background:#fff;padding-left:5px;margin-bottom:2px; width:800px">
                        <span style="font-size:11px;font-weight:600;color:#409ef2">
                            树状工艺【
                                <el-link @click="addRec" :disabled="addBool" :underline="false" style="font-size:12px; " ><i class="iconfont icon-xinzeng"></i>新增</el-link>
                                <el-link @click="btnEdit(false)" :disabled="!btnBool&&editBool" :underline="false" style=" margin-left:15px;font-size:12px" ><i class="iconfont icon-bianji"></i>编辑</el-link>   
                            】
                        </span>
                        <el-dropdown style="margin-left:5px; "  size="mini"   @command ="downClick">
                            <el-button type="danger" size="small" style="height:30px;width:65px">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  command="cancel"> 
                                    <div style="line-height:30px"> <i class="iconfont icon-chexiao"></i>取消编辑 </div>
                                </el-dropdown-item>
                                <el-dropdown-item divided command="insert" :disabled="btnBool"> 
                                    <div  style="line-height:30px"> <i class="iconfont icon-xinzeng"></i>插入工序 </div>
                                </el-dropdown-item>
                                <el-dropdown-item divided command="modify" :disabled="btnBool"> 
                                    <div  style="line-height:30px"> <i class="iconfont icon-bianji"></i>变更工序 </div>
                                </el-dropdown-item>
                                <el-dropdown-item divided :disabled="btnBool" command="ref1"> 
                                    <div  style="line-height:30px"> <i class="iconfont icon-xinzeng"></i>引入单层BOM </div>
                                </el-dropdown-item>
                                <el-dropdown-item divided :disabled="btnBool" command="delete">
                                    <div  style="line-height:30px"> <i class="iconfont icon-shanchu1"></i>删除 </div>              
                                </el-dropdown-item>
                                <el-dropdown-item divided :disabled="btnBool" command="ref2">
                                    <div  style="line-height:30px"> <i class="iconfont icon-xinzeng"></i>引入树状BOM</div>
                                </el-dropdown-item>
                                <el-dropdown-item divided :disabled="!btnBool" command="net">
                                    <div  style="line-height:30px"> <i class="iconfont icon-xinxi"></i>净物料</div>
                                </el-dropdown-item>
                                <el-dropdown-item divided command="sort">
                                    <div  style="line-height:30px"><i class="iconfont icon-paixu-shengxu"></i>排序</div>  
                                </el-dropdown-item>
                                <el-dropdown-item divided command="refone">
                                    <div  style="line-height:30px"><i class="iconfont icon-shuaxin"></i>刷新单层BOM</div>  
                                </el-dropdown-item>
                                <el-dropdown-item divided  command="report">
                                    <div  style="line-height:30px"><i class="iconfont icon-a-baobiaoguanlibaobiao"></i>报表</div> 
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div :style="{height: treeHeight,overflow:'auto'}" >
                        <el-tree :data="treeData" 
                                    :props="defaultProps" 
                                    @check="handleNodeClick" 
                                    default-expand-all
                                    node-key="id"                       
                                    :style="{'background':'#fff','overflow':'auto',height:treeHeight  }" 
                                    highlight-current
                                    ref="eltree"
                                    show-checkbox
                                    check-strictly 
                                    check-on-click-node
                                    v-loading="loading"
                                    element-loading-text="加载中"
                                    element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(255, 251, 255, 0.8)"
                                    :expand-on-click-node="false">
                            <template v-slot="{node,data}">                                
                                <span v-if="data.parentid =='#' " >
                                    <div style="display:flex;line-height:25px; ">
                                        <div style="font-size:14px; color:#409efe;width:280px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden" :title="node.label"><i class="iconfont   icon-kucunguanli" style="color:#409eff;font-size:18px;margin-right:4px;"></i>{{ node.label}} 【 {{treePid}} : {{data.icon}}】</div>
                                        <!-- <div style="font-size:14px; color:#0080FF;width:40px; "> {{ data.icon}} </div> -->
                                    </div>
                                </span>                  
                                <span v-else > 
                                    <div style="display:flex">
                                        <div style="color:#2b85e4;font-size:12px;min-width:200px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden " :title="`${node.label}` +`${data.icon}`"><i class="iconfont icon-fenzhijiedian" style="color:#E6A23C;font-size:14px;margin-right:4px;"></i>{{ node.label}}   {{data.icon}}</div>
                                        <!-- <div style="font-size:12px; color:#0080FF;width:40px; "> {{ data.icon}} </div> -->
                                    </div>
                                </span>
                            </template>
                        </el-tree>  
                    </div>
                </template>
                <template slot="paneR">  
                    <split-pane  :min-percent='20' :default-percent='50' split="vertical">
                        <template slot="paneL">    
                            <!-- 新增、编辑表单 -->
                            <div style="border-bottom:1px solid #ccc;line-height:35px;height:35px;background:#fff;padding-left:5px;margin-bottom:2px; ">
                                <span style="font-size:12px;font-weight:600;color:#409ef2">工序物料</span>
                                【
                                    <el-link @click="saveDtl"  :underline="false" :disabled="editFlag"  icon="iconfont icon-baocun">保存物料内容</el-link>
                                】
                                <el-link @click="showRmk" :underline="false"><i class="iconfont icon-tishi" style="color:green;font-weight:700;font-size:20px"></i></el-link>
                            </div>
                            <el-table  :data="dtlData" 
                                border                           
                                size="small"
                                class="custom-table-border"
                                :cell-style="{padding:'2px','font-size':'12px'}"
                                :height="treeHeight" 
                                :header-cell-style="{ 'color':'#389','text-align':'center' }"
                                :row-key="getDtlKey"
                                :row-class-name="tabRowClass"
                                @row-click="getRowClick"
                                cell-class-name="clearPadding"
                                v-loading="v_loading"
                                element-loading-background = "rgba(255, 255, 255, .5)"
                                element-loading-text = "加载中，请稍后..."
                                element-loading-spinner = "el-icon-loading"
                                ref="refdtl"
                                highlight-current-row > 
                                <el-table-column label="序号" type="index" width="45" ></el-table-column>
 
                                <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                                    :prop="item.key" 
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"                                  
                                    :sortable="item.sortable=='N'"
                                    :min-width="item.width">
                                    <template slot-scope="scope">
                                        <span v-if="editFlag">
                                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                            <span v-else v-text="scope.row[item.key]" ></span>
                                        </span>
                                        <span v-else>
                                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                            <el-input @keyup.enter.native="nextLine(item.key)" :disabled="scope.row['BOMFLAG']=='N'" :ref="scope.$index+item.key" v-else-if="item.key=='POSITION'||item.key=='RMK'" size="mini" style="width:100%"  v-model="scope.row[item.key]"></el-input>
                                            <el-input type="number" @keyup.enter.native="nextLine(item.key)" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" :ref="scope.$index+item.key" :disabled="scope.row['BOMFLAG']=='N'"  v-else-if="item.key=='QTY'" size="mini" style="width:100%"  v-model="scope.row[item.key]"></el-input>                       
                                            <span v-else v-text="scope.row[item.key]" ></span>
                                        </span>
                                    </template>
                                </el-table-column> 
                                <el-table-column
                                    fixed="right"
                                    label="操作"
                                    align="center"
                                    width="65">
                                    <template slot-scope="scope">
                                        <!-- <el-button size="mini"  type="text" icon="iconfont icon-shanchu1" @click="delRec(scope.row,scope.$index)">删除</el-button>   -->
                                        <el-link :disabled="btnBool" @click="delRec(scope.row,scope.$index)" :underline="false" style="font-size:12px; "><i class="iconfont icon-shanchu1" style="font-size:12px"></i>删除</el-link> 
                                    </template>
                                </el-table-column> 
                            </el-table>   
                 
                        </template>
                        <template slot="paneR"> 
                            <div style="border-bottom:1px solid #ccc;line-height:35px;height:35px;background:#fff;padding-left:5px;margin-bottom:2px; ">
                                <span style="font-size:12px;font-weight:600;color:#409ef2">物料清单</span>
                                【<el-link :disabled="btnBool" @click="addBom" :underline="false" style=" margin-left:5px;margin-right:5px;"><i class="iconfont icon-xinzeng"></i>插入BOM层</el-link>】
                            </div> 
                            <split-pane  :min-percent='20' :default-percent='35' split="vertical">
                                <template slot="paneL">                     
                                    <div :style="{'min-width':'80px','overflow':'auto','height':tabHeight }">
                                        <el-input placeholder="请输入物料进行过滤" v-model="filterMat" size="medium"  ></el-input> 
                                        <el-tree :data="matData" 
                                                    :props="defaultProps" 
                                                    @node-click="tMatClick" 
                                                    node-key="id"    
                                                    default-expand-all     
                                                    :style="{'background':'#fff','overflow':'auto',height:refHeight ,'border':'1px solid #ccc' }"
                                                    highlight-current
                                                    :filter-node-method="filterMth"
                                                    ref="refmtree"
                                                    :expand-on-click-node="false">
                                            <template v-slot="{node,data}">                                     
                                                <span v-if="data.id ==0 "  >
                                                    <span  style="color:#409eff;font-size:14px;"><i class="iconfont icon-mokuai1" style="color:#409eff;font-size:18px;"></i> {{ node.label}} </span>
                                                </span>                  
                                                <span v-else  > 
                                                    <span style="color:#606266;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i> {{ node.label}} </span>
                                                </span>
                                            </template>
                                        </el-tree>
                                    </div>
                                </template>
                                <template slot="paneR">
                                    <el-table  :data="rawData" 
                                        class="custom-table-border"
                                        border                            
                                        disabled-hover
                                        size="small"
                                        cell-class-name="clearPadding"
                                        :cell-style="{padding:'2px'}"
                                        :height="bomHeight" 
                                        v-loading="t_loading"
                                        element-loading-background = "rgba(255, 255, 255, .5)"
                                        element-loading-text = "加载中，请稍后..."
                                        element-loading-spinner = "el-icon-loading"
                                        header-cell-class-name="clearPadding"
                                        :header-cell-style="{ 'color':'#389','text-align':'center'}"
                                        ref="refmat" 
                                        highlight-current-row>
                                        <el-table-column label="序号" type="index" width="50" fixed>
                                            <el-table-column label="序号" type="index" width="50" fixed>
                                                <template slot="header"  >
                                                    <el-link   @click="rowShow" style="font-size:12px;color:#404eff"> 
                                                        <el-tooltip content=" 清除条件" effect="light">
                                                            <i class="iconfont icon-shanchu1"  ></i>
                                                        </el-tooltip>
                                                    </el-link>
                                                </template>
                                            </el-table-column>
                                        </el-table-column>
                                        <el-table-column  v-for="(item,index) in matArr.filter(item=>item.thide=='N')" :key="index"
                                            :prop="item.key"
                                            :label="item.title"
                                            show-overflow-tooltip
                                            :align="item.align"                                  
                                            :sortable="item.sortable=='N'"
                                            :min-width="item.width">
                                            <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align" show-overflow-tooltip :min-width="item.width">
                                                <template slot="header" slot-scope="scope">
                                                    {{scope.row}}
                                                    <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_matrow[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                                                    <el-input type="number" placeholder="数字框"  @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_matrow[item.key]" style="width:100%"> </el-input> 
                                                    <el-input :disabled="item.edcss=='image'||item.edcss=='checkbox'" v-else @keyup.enter.native="inputQry"  v-model="v_matrow[item.key]" size="mini" placeholder="请输入" ></el-input> 
                                                </template>
                                                <template slot-scope="scope">
                                                    <el-checkbox v-if="item.key=='SEL'" @change="rowClick(scope.row)" true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                                                    <el-input v-else-if="item.key=='QTY'" :id="scope.$index+ item.key " size="mini" style="width:100%"  v-model="scope.row[item.key]"></el-input>
                                                    <span v-else v-text="scope.row[item.key]" ></span>
                                                </template>
                                            </el-table-column>
                                        </el-table-column>                           
                                    </el-table>  
                                    <div style="padding-left:5px;overflow: hidden;display:flex;line-height:30px;height:34px;background:white;font-size:12px;margin-top:5px">
                                        <div style="float: left;">
                                            <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
                                        </div>
                                    </div>                                  
                                </template>
                            </split-pane>
                        </template>
                    </split-pane>
                </template>               
            </split-pane>
            <!-- 添加半成品 -->
            <el-dialog v-dialogDrag   :visible.sync="prdWin" width="1300px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="3vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">单层BOM资料</span>
                </div> 
                <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;  ">
                <span v-for="item in tabArr" :key='item.key'>
                    <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                </span>
                </el-select>
                <el-select v-model="oper"  size="small" style="width:110px;margin-bottom:3px;margin-left:2px; ">
                    <el-option v-for="item in operArr" :label="item.CNAME" :value="item.SUBNO" :key="item.IDSEQ"></el-option>
                </el-select>
                <el-input placeholder="请输入查询值" @keyup.enter.native="qryPrdData" v-model="textparam" size="small" style="width:260px;margin-left:2px;margin-top:3px; ">
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryPrdData" style="color:#409eff"></el-button>
                </el-input>                      
                <el-table  :data="tabData" 
                    border         
                    class="custom-table-border"                   
                    disabled-hover
                    :cell-style="{padding:'2px'}"
                    style="overflow:auto;margin-top:1px;"
                    size="small"
                    :height="subHeight" 
                    ref="refjob" 
                    highlight-current-row>
                    <span v-for="(item,index ) in tabArr" :key="index">
                        <el-table-column  v-if="item.thide==='N'  "
                            :prop="item.key"
                            :label="item.title"
                            :fixed="item.key=='RN'"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            sortable
                            :min-width="item.width">
                        </el-table-column> 
                    </span>    
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="110">
                        <template slot-scope="scope">
                            <el-button  size="mini"  type="text" icon="iconfont icon-xinzeng" @click="addTo(scope.row )">添加到Bom</el-button>
                        </template>
                    </el-table-column>              
                </el-table>  
            </el-dialog>
            <!-- 添加工序 :filter-method="filterJob"  v-selmore:rangeNumber="loadMore(rangeNumber)" .slice(0,rangeNumber)-->
            <el-dialog v-dialogDrag   :visible.sync="jobWin" width="680px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="3vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">工序选择</span>
                </div> 
                <div style=" line-height:40px ;height:45px;display:flex">
                    <div style="font-size:12px;width:80px;text-align:left; ">请选择工序</div>
                    <el-select filterable  v-model="v_jobno" style="width:550px" clearable>                            
                        <el-option v-for="(item,index)  in jobData"  :key="index" :value="item.IDNO" :label="item.JOBWKNM" > </el-option>   
                    </el-select>   
                </div>  
                <div style=" line-height:40px ;height:45px;display:flex;margin-top:20px">
                    <div style="font-size:12px;width:80px;text-align:left; ">工序顺序</div>
                    <el-input-number v-model="v_jobnum"  style="width:200px;"></el-input-number>  
                </div>  
                <div style=" line-height:30px ;height:30px;display:flex;font-weight:700;font-size:12px;margin-top:20px">
                    备注：当工序顺序为空时，默认插入在 选中节点的最后面，如果想插在同一父节点下的某个工序前，就设置此顺序
                </div>
                <div slot="footer">              
                    <el-button  size="small"  type="primary" :disabled="v_bool" icon="iconfont icon-baocun" @click="addJob" style="margin-right:6px">确定添加</el-button> 
                    <el-button icon="iconfont icon-xinzeng" @click="creJob" type="info" size="small" style="margin-right:6px;margin-left:50px"> 新增工序 </el-button>
                </div> 
            </el-dialog>
            <el-dialog v-dialogDrag   :visible.sync="jobEdit" width="680px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="3vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">工序变更</span>
                </div> 
                <div style=" line-height:40px ;height:45px;display:flex">
                    <div style="font-size:12px;width:80px;text-align:left; ">请选择工序</div>
                    <el-select filterable  v-model="v_jobno2" style="width:550px" clearable>                            
                        <el-option v-for="(item,index)  in jobData"  :key="index" :value="item.IDNO" :label="item.JOBWKNM" > </el-option>   
                    </el-select>   
                </div>  
                <div slot="footer">              
                    <el-button  size="small"  type="primary" icon="iconfont icon-baocun" @click="modJob" style="margin-right:6px">确定 </el-button> 
                    <el-button icon="iconfont icon-shanchu" @click="jobEdit=false" type="info" size="small" style="margin-right:6px;margin-left:50px"> 取消 </el-button>
                </div> 
            </el-dialog>
            <!-- 提示框 -->
            <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                    <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
                </div>
                <div style="line-height:30px;display:flex">
                    <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                    <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
                </div>
                <span slot="footer"  >
                    <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
 
            <!-- 新增工序 -->
            <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="jobForm" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 新增记录  </span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <Form :model="jobRow" :label-width="110" ref="jobmodel"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in jobArr" :key="index" >
                            <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                                <el-date-picker :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="jobRow[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="jobRow[item.key]" style="width:100%" ></el-input-number>   
                                <el-select :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="jobRow[item.key]"   style="width:100%">
                                    <el-option v-for="(it,ind) in comboArr[item.key]" :key="ind" :label="it.CNAME" :value="it.CODE"></el-option>
                                </el-select>
                                <el-input :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="jobRow[item.key]" ></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </div>
                <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                    <span style="float:right">
                        <el-button type="info" @click="jobForm=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button @click="saveJob" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button>                 
                    </span>
                </div>
            </el-dialog>
            <!-- 编辑BOM内容 -->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="dtlForm" width="400px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 设置排序 </span>
                </div> 
                
                <div style="line-height:35px;display:flex">
                    <span style="width:80px;text-align:right;margin-right:6px;">编码</span>
                    <el-input  type="text" readonly  v-model="sort.code"  style="width:300px;"></el-input> 
                </div>
                <div style="line-height:35px;display:flex;margin-top:20px;">
                    <span style="width:80px;text-align:right;margin-right:6px;">节点名称</span>
                    <el-input  type="text" readonly  v-model="sort.cname"  style="width:300px;"></el-input>
                </div>
                <div style="line-height:35px;display:flex;margin-top:20px; ">
                        <span style="width:80px;text-align:right;margin-right:6px;">排序</span>
                        <el-input-number  v-model="sort.num"  style="width:300px;"></el-input-number>  
                </div>
 
                <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                    <span style="float:right">
                        <el-button type="info" @click="dtlForm=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button @click="saveSort" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button>                 
                    </span>
                </div>
            </el-dialog>
            <!-- 引入单层BOM方式 -->
            <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="bomMth" width="600px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 引入方式  </span>
                </div> 
                <div style="line-height:40px; "> 
                    <el-radio-group v-model="impFlag">
                        <el-radio label="Y">引入后会修改</el-radio>
                        <el-radio label="N">引入后不修改</el-radio>
                    </el-radio-group>  
                </div> 
                <div style="display:flex; line-height:40px;margin-top:15px;margin-bottom:10px">
                    <div style="font-size:12px;width:150px;line-height:35px">引入单层BOM份数：</div>
                    <el-input   type="number"  @keydown.native="e=>e.returnValue=(['e','E','+','.'].includes(e.key))?false:e.returnValue"  v-model="v_qty"  style="width:100px;line-height:35px"  ></el-input>   
                </div>
                <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px; " >
                    <span style="float:right">
                        <el-button type="info" @click="bomMth=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button @click="addPrd" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button>                 
                    </span>
                </div>
            </el-dialog>
            <!-- 引入树状BOM方式 -->
            <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="treeWin" width="600px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 引入树状BOM</span>
                </div> 
                <div style="line-height:40px;display:flex">
                    <div style="width:80px">产品编码</div>
                    <el-select  v-model="treeNo"  style="width:100%" filterable  placeholder="请选择">
                        <div v-for="(item,index) in prdArr" :key="index"  >
                            <el-option   :value="item.MATNO" :label="item.MATLABEL"  > </el-option>
                        </div>
                    </el-select>
                </div>
                <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px; " >
                    <span style="float:right">
                        <el-button type="info" @click="treeWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button @click="treePrd" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 确定 </el-button>                 
                    </span>
                </div>
            </el-dialog>
            <!-- 复制产品BOM -->
            <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="cpWin" width="580px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 复制到产品</span>
                </div> 
                <div style="line-height:40px;display:flex">
                    <div style="width:100%">来源产品编码：{{v_tabrow['MATNO']}}</div>                      
                </div>
                <div style="line-height:40px;display:flex">
                    <div style="width:100%">来源产品名称：{{v_tabrow['MATNM']}}</div>                      
                </div>
                <div style="line-height:40px;display:flex">
                    <div style="width:120px;color:red">目标产品编码</div> 
                    <el-select  v-model="treeNo"  style="width:100%" filterable  placeholder="请选择">
                        <div v-for="(item,index) in tarArr" :key="index"  >
                            <el-option  :value="item.MATNO" :label="item.MATLABEL"  > </el-option>
                        </div>
                    </el-select>
                </div>
                <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:20px; " >
                    <span style="float:right">
                        <el-button type="info" @click="cpWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                        <el-button @click="cpBomPrd" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 确定 </el-button>                 
                    </span>
                </div>
            </el-dialog>
            <!-- 提示说明 -->
            <el-dialog v-dialogDrag :visible.sync="rmkWin" width="820px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">说明</span>
                </div> 
                <div style="height:560px;overflow-y:auto">
                     <div style="line-height:30px;font-size:12px" v-for="(item,index) in rmkArr" :key="index">{{item.CNAME}}</div>   
                </div>
                <span slot="footer"  >
                    <el-button type="info" @click="rmkWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                </span>
            </el-dialog>
            <!-- report preview -->
            <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
                </div> 
                <div style="height:88vh;overflow-y:auto">
                    <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
            </el-dialog>
            <!-- 引用报表 -->
            <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
                </div> 
                <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
            </el-dialog>
            <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <el-image  src="/assets/authorize/loading.gif" ></el-image>  
            </el-dialog>
            <!-- 引用选择框 -->
            <el-dialog  v-dialogDrag v-if="btnWin"  :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
                </div> 
                <pub-win v-bind:tabCol ="tableCol"  v-bind:v_cond="t_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
            </el-dialog>
        </template>
    </split-pane>    
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate ,jsuuid} from '../../api/Select' 
 
import pubWin from '../datamgt/pubwin.vue'
import repWin from '../datamgt/repWin.vue' 
export default {
    name:'tree_bom',
    data () {
        return {
            btnWin:false,
            tableCol :[],
            v_key2 :'',
            v_random:'',
            t_cond:'',
            v_table:'',
            v_value2 :'',
            loadWin:false,
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repUrl:'',
            bomMth:false,
            cpWin:false,
            repWin:false,
            treeNo:'',
            bomRow:{},
            dtlRow:{},
            okData:[],
 
            sendVal:'PRD',
            jobWin:false,
            loading:false,
            rawData:[],
            dtlForm:false,
            findWin:false,
            prdWin:false,
            comboArr:[],
            promptWin:false,
            dtlFlag:'create',
            treeData:[],
            treeRow:{},
            v_parentid:'',
            btnBool:true,
            rmkWin:false,
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                parentid:'parentid',
                label: 'label',
                flag:'flag',
                idseq:'idseq',
                lvl:'lvl',
                stfg:'stfg',
 
            },
            prdRow:{},
            filterText:'',  
            filterMat:'', 
            supFlag:'',
            addFlag:'create',
            smpWin:false,
            treeid:'-1',
            nodeLabel:'',
            rowDtl:{},
            showVisible:false,
            matArr:[],
            prdArr:[],
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            defpct:18,
            v_sort:'',
            v_idseq:'',
            input_hold:'请输入内容...',
            ruleValidate:{'BOMTY':[{ required: true, message: '请选择', trigger: 'blur' }]},
            v_hide:'N',
            selparam:'',
            textparam:'',
            selparam2:'MATTYNM',
            oper2:'like',
            txtparam2:'',
            oper:'like',
            selparam3:'JOBNM',
            textparam3:'',
            oper3:'like',
            jobRow:{},
            v_tabrow: {},
            bomArr:[],
            goPage:'',
            rowIdseq:'',
            impFlag:'N',
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            current:1,
            v_current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            txtArr1:[],
            v_manyurl:'xuper_auth/getBaseData' , //api请求路径      
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            tarArr:[],
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            allPrd:[], //所有产品数据集合
            dataCount:0,
            prdCount:0,
            rowSize:100,
            dtlCol:[],
            matCol:[],
            lvl:'',
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            rmkArr:[],
            jobForm:false,
            v_bool:false,
            tyArr:[],  
            bomData:[],
            v_lvl:'',
            dtlIndex:'',
            smpFlag:'',
            parentno:'',
            bomty:'',
            active:'first',
            ptree:false,
            pData:[],
            tabArr:[],
            tabData:[],
            allData:[],
            treePid:'0',
            treeMid:'0',
            txtparam:'',
            r_loading:false,
            t_midmatno:'',
            jobArr:[],
            jobData:[],
            editFlag:true,
            sort:{code:'',cname:'',num:undefined},
            treeWin:false,
            chkIndex: 0,
            v_jobno: '',
            rangeNumber:40,
            v_jobnum: undefined,
            repArr:[],
            v_loading:false,
            t_loading:false,
            v_stfg:'N',
            v_qty:1,
            v_jobno2:'',
            jobEdit:false,
            v_row:{},
            v_matrow:{},
            currentSelectedNode: null // 用于记录当前选中的节点数据
        }
    },
    watch: {
 
        filterMat(val) {
            this.$refs.refmtree.filter(val);
        }  
    } ,
    computed: {
        subHeight: function() {
            return (window.innerHeight - 210) + 'px';
        }, 
        tabHeight: function() {
            return (window.innerHeight - 5) + 'px';
        },
        bomHeight: function() {
            return (window.innerHeight - 160) + 'px';
        },
        refHeight: function() {
            return (window.innerHeight - 155) + 'px';
        },
        matHeight: function() {
            return (window.innerHeight - 155) + 'px';
        },
        selHeight: function() {
            return (window.innerHeight - 80) + 'px';
        },
        treeHeight: function() {
            return (window.innerHeight - 130) + 'px';
        },
        tabWidth: function() {
            return (window.innerWidth - 120) + 'px';
        },
 
    },
    mounted () {
        getBaseData(this.v_manyurl+'','userno',this.v_username,'frmidseq','16532','v_sys_user_priv',' and issel=\'Y\'').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        }) 
        getBaseData(this.v_manyurl+'','userno',this.v_username,'frmidseq','16532','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','398578','','','v_sys_base',' order by sortby,idseq').then(res=>{
            this.rmkArr =res.result 
        })
        getBaseData(this.v_manyurl+'','CORPID',this.v_corpid ,'','','V_PRD_BOM_GP','').then(res=>{
            this.tyArr =res.result
        })
        //产品
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_prd_bom',' and idseq in (select idseq from prd_bomdtl group by idseq)').then(res=>{
            this.prdArr =res.result
        })
        
        this.comSelect()
        this.qryBomData('') //产品树目录
        this.qryMatData() //物料树目录
        this.queryEvent('')
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    components: {
 
        repWin,
        pubWin,
    },
    methods: {
      
        matChg(){            
            let v_cond =''
            if (this.txtArr1.length>0){
                this.txtArr1.forEach(item=>{
                    if (v_cond){
                        v_cond =v_cond +',\'' +item +'\''
                    }else{
                        v_cond ='\'' +item +'\''
                    }
                })
                v_cond =' and mattynm in (' +v_cond +')'
            }else{
                v_cond =' and 1=1'
            }
            this.qryBomData(v_cond)
        },
        clearRow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.qryBomData('')
        } ,
        qryBomData(t_cond){
            let cond_=' and stfg!=\'X\'' ,v_edcss='',v_cond=''
 
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.bomArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_edcss =='number'){
                        cond_ =cond_ +' and '+item+'>='+  this.v_row[item] 
                    }else{
                        cond_ =cond_ +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                    }
  
                }
            })
            this.getBomList(cond_+t_cond)
        },
        btnSure(obj){
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'matno', p_value:obj['IDNO'],p_key2:'corpid', p_value2:this.v_corpid, p_table:'v_prd_bom'},
            }).then(res=>{ 
                if (res.result.length>0){
                    this.promptWin =true
                    this.prompt ='此产品已存在树状BOM，请核查'
                }else{
                    let v_mainRow={MATNO:obj['IDNO'] ,'IDSEQ':'',QTY:'1',BOMTY:'16212',BOMDTTM:getDate(),VER:'1',CORPID:this.v_corpid} //默认自制
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(v_mainRow,{CORPID:this.v_corpid})), p_table:'PRD_BOM',frmid:'16532'},
                    }).then( res=>{
                        if (res.code=='200'){
                            this.treePid=obj['IDNO']
                            this.qryBomData('') //重新刷新产品类别
                            this.freshBom( obj['IDNO']) // 刷新树状BOM 
                            this.btnWin=false
                            this.btnEdit(false)
                        }else{
                            this.prompt=res.result
                            this.promptWin =true
                        }
                    })
                }
            }) 
        },
 
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.rawData = this.allData.slice(_start,_end);
        },
        changePrd(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.v_current =index
            this.bomData = this.allPrd.slice(_start,_end);
        },
        //字段查询
        inputQry(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_matrow).forEach(item=>{
                if (this.v_matrow[item] ){
                    this.matArr.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_matrow[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_matrow[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_matrow[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_matrow[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.queryEvent(v_cond )
        },
        rowShow(){
            Object.keys(this.v_matrow).forEach(item=>{
                this.v_matrow[item] =''
            })
            this.queryEvent('')
        } ,
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full') 
            }
        },
        loadMore(n) {
            return () => this.rangeNumber += 20 //每次滚动到底部可以新增条数 
        },
        downClick(val){
            if (val =='cancel'){
                this.btnEdit(true)
            }else if (val =='insert'){ //插入工序
                this.jobAdd()
            }else if (val =='modify'){ //变更工序
                this.jobUpd()
            }else if (val =='ref1'){ //引入单层BOM
                this.jobRef()
            }else if (val =='delete'){ //删除
                this.delLvl()
            }else if (val =='ref2'){ //引入多层BOM
                this.treeRef()
            }else if (val =='net'){ //净物料
                this.netMat()
            }else if (val =='refone'){ //刷新单层BOM
                this.refOne()
            }else if (val =='sort'){ //排序
                this.sortBom()
            } else if (val =='report'){ //报表
                if (this.treePid =='0'){
                    this.promptWin =true
                    this.prompt ='请选择产品'
                }else {
                    this.v_idno =this.treePid
                    this.repDlg =true
                    this.v_replist =this.repArr                   
                }
            }
        },
        //表格行 按回车键 到下一行
        nextLine(key){
            this.chkIndex = this.chkIndex +1
            if (this.chkIndex >=this.dtlData.length) {
                this.chkIndex =0
            }
            this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
            this.$refs[this.chkIndex+key][0].focus()               
        },
        getRowClick(row,column){
            this.chkIndex =row.index
        },
        showRmk(){
            this.rmkWin =true
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
            if (row['BOMFLAG']==='N'){
                return 'warning-row'
            }
        },
        delRec(row ,index){
            if (row['BOMFLAG']=='N'){
                this.promptWin =true
                this.prompt ='预制件物料不能删除'
            }else{
                this.$confirm('你确定要删除此行物料吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row.IDSEQ ,p_key2:'lstseq',p_value2:row.LSTSEQ ,p_table:'prd_BOMDTL'},
                    }).then(res=>{ 
                        if(res.code==='200'){
                            this.dtlData.splice(index,1)    
                        }
                    })
                }).catch(()=>{})
            }
        },
        //保存排序
        saveSort(){
            this.$axios({
                method: 'post',
                url:'xuper_auth/updateRec',
                data: {p_key:'matno',p_value:this.currentSelectedNode.id,p_key2:'parentno',p_value2:this.v_parentid,p_table:'PRD_BOMDTL',p_cond:' set jobnum='+ this.sort['num']},
            }).then(res=>{
                this.dtlForm=false
                this.getData(this.treePid)
            })
        },
        //刷新单层BOM  
        refOne(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if(checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择一个节点' 
            }else{
                // 判断是否为 单层bom select * from prd_bomdtl where idseq=494941 and matno='J0000005807';
                let t_matno=this.currentSelectedNode.id, t_idseq=this.currentSelectedNode.idseq
                
                this.$axios({
                    method: 'post',
                    url:this.v_manyurl ,
                    data: {p_key:'idseq',p_value:t_idseq,p_key2:'matno',p_value2:t_matno , p_table:'prd_BOMDTL' },
                }).then(res=>{
                    let v_bomno =res.result[0]['BOMNO']
                    if (!v_bomno){
                        this.promptWin=true
                        this.prompt ='请选择节点为单层bom' 
                    }else{
                        let v_msg ='你确定要刷新单层bom:'+v_bomno+'到此产品下吗？'
                        this.$confirm(v_msg,'提示',{
                            confirmButtonText: '确定',
                            cancelButtonText:'取消',
                            customClass:'messageBox',
                            showClose:false,
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            type:'info',
                        }).then(()=>{
                            this.loadWin =true
                            const payload = {corpid:this.v_corpid,p_idseq:t_idseq,p_action:'TREE_ONEBOM#'+t_matno,p_user:this.v_username,p_cond:''}
                            this.$axios({
                                method: 'post',
                                url:'/xuper_oss/call_package',
                                data: payload,
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.loadWin =false
                                    this.promptWin =true
                                    this.prompt =res.result                                    
                                }else{
                                    this.getDtlList(t_idseq ,t_matno)
                                    this.loadWin =false
                                }
                            })
                            
                        }).catch(()=>{})   
                    }
                })
            }
        },
        //排序
        sortBom( row, index ){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            // if (checkedKeys.length > 0) {
            // const selectedId = checkedKeys[0];
            // // 获取完整节点数据
            // const selectedNode = this.$refs.eltree.getCheckedNodes()[0];
            // }
            if( checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择排序的节点' 
            }else if(this.treePid ==this.currentSelectedNode.id){
                this.promptWin=true
                this.prompt ='根节点不需设置排序' 
            }else {
                this.dtlForm =true
                this.sort['code'] =this.currentSelectedNode.id
                this.sort['cname']=this.nodeLabel;    
                this.sort['num'] =this.v_sort      
            }
        },
        saveDtl(){
            for (let i =0 ; i <this.dtlData.length ; i++){
                let v_pos =this.dtlData[i]['POSITION'] ||''
                let v_rmk = this.dtlData[i]['RMK'] || ''
                let v_qty =this.dtlData[i]['QTY']
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:this.dtlData[i]['IDSEQ'],p_key2:'lstseq',p_value2:this.dtlData[i]['LSTSEQ'],p_table:'PRD_BOMDTL',p_cond:' set qty='+v_qty+',POSITION=\''+v_pos+'\',RMK=\''+v_rmk+'\''},
                }).then(res=>{
                    if (res.code=='200'){
                         //
                    }else{
                        this.promptWin=true
                        this.prompt =res.result
                    }
                })
            }
            this.$message({
                message: '已保存BOM内容',
                type: 'success'
            })
        },
        //保存工序
        saveJob(){
            if (!this.jobRow['WKNO']){
                this.promptWin =true
                this.prompt='工作中心不能为空'
                return
            }if (!this.jobRow['JOBNM']){
                this.promptWin =true
                this.prompt='工作名称不能为空'
                return
            }
            //发起保存请求   
            this.$refs['jobmodel'].validate((valid) => {
                if (valid) {
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.jobRow,{CORPID:this.v_corpid})), p_table:'bs_job',frmid:'16521'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            this.jobForm =false   
                            this.getJobList('')   
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            })
        },
        creJob(){
            this.jobForm =true
        },
        addRec(){
            this.v_table ='V_BS_MATQRY'
            this.tableCol =this.matCol
            this.v_key2 =''
            this.v_value2 = '' //and idno not in (select matno from prd_bom)
            this.t_cond =' and ishide=\'N\' and modelno in (\'PRD\',\'MIX\') '
            this.btnWin =true
        },
 
        btnEdit(val){
            if (this.v_stfg=='Y'){
                this.promptWin =true
                this.prompt='此产品已审核，不能编辑'
            }else{
                this.btnBool= val
                if (val){
                    this.defpct =18
                    this.editFlag=true
                }else{
                    this.defpct =0
                    this.editFlag=false
                }
                this.$nextTick(() =>{                    
                    this.$refs.eltree.setCurrentKey(this.treePid) 
                })
            }
        },
 
        //添加净物料到 bom
        matSave(selArr){
            let v_dup=''
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (checkedKeys.length ==0){
                this.promptWin =true
                this.prompt ='请选择一个节点'
            }else if(this.bomty=='N'){
                this.promptWin =true
                this.prompt ='预制件下面不能插入，请核查'
            }else{
                let v_parent =this.treeData.length==0?this.treePid:this.currentSelectedNode.id
                this.$axios({ //首先获取产品 IDSEQ
                    method: 'post',
                    url:this.v_manyurl ,
                    data: {p_key:'corpid',p_value:this.v_corpid,p_key2:'matno',p_value2:this.treePid, p_table:'V_prd_BOM' },
                }).then(async res=>{ 
                    let idseq_ =res.result[0]['IDSEQ']
                    for (let k=0 ;k<selArr.length; k++){ //判断物料是否存在
                        await this.$axios({
                            method: 'post',
                            url:this.v_manyurl ,
                            data: {p_key:'idseq',p_value:idseq_,p_key2:'matno',p_value2:selArr[k]['MATNO'],p_key3:'parentno',p_value3:v_parent, p_table:'V_prd_BOMDTL' },
                        }).then(async (res)=>{
                            if (res.result.length==0){
                                let v_treeRow={MATNO:selArr[k]['MATNO'],PARENTNO:v_parent ,'IDSEQ':idseq_ ,QTY:selArr[k]['QTY'], BOMDTTM:getDate() ,LVL:this.v_lvl,BOMFLAG :'Y' }  
                                await this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(Object.assign(v_treeRow,{'LSTSEQ':''})), p_table:'PRD_BOMDTL',p_idseq:idseq_},
                                }).then(res=>{
                                    if (res.code!=='200'){
                                        this.promptWin =true
                                        this.prompt=res.result
                                    }
                                })   
                            }else{
                                v_dup=v_dup+','+ selArr[k]['MATNO']
                            } 
                        })
                        if (k ==selArr.length-1){
                            setTimeout(() => {
                                if (v_dup!==''){
                                    this.promptWin =true
                                    this.prompt ='以下物料：'+v_dup +' 已存在，不重复插入！'
                                }else {
                                    this.getMain(v_parent)
                                    this.getData(this.treePid)
                                }
                            }, 300);       
                        }
                    }   
                })
            }
        },
 
        rowClick(row){  
            let bool =true
           if (row['SEL']=='Y') {
            this.okData.some(item=>{
                if (item['IDNO']==row['IDNO']){
                    bool =false
                    return true
                } 
            })
            if (bool)   
               this.okData.push(row)
           }
        },
        editCurrRow(rowId,str){
            this.editIndex=rowId //不加此，整个列都会一块变成可编辑
            this.showVisible=true
            let id=rowId +str
            //也可以用 this.$nextTick, 个人感觉加个0.1秒的延时比下次渲染灵活一点
            setTimeout(()=>{
                document.getElementById(id).focus()
            },100)
        },
        tMatClick(data){
            this.treeMid =data.id            
            this.queryEvent('')
        },
        getMdata(cond) {  
            var vm=this;   
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData' ,
                data: {p_table:'v_mat_TYPE',p_cond:' and corpid=\''+this.v_corpid +'\''}
            }).then(function(res){                  
                vm.matData =res.result   
                if(res.result.length > 0 ){
                    vm.$nextTick(() =>{
                        //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                        vm.$refs.refmtree.setCurrentKey('0')
                    })
                }  
                 
            })                                
        },
        //节点过滤
 
        filterMth(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1||data.id.indexOf(value) !== -1
        },
 
        //工序明细
        getJobList(cond){     
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'', p_value:'',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_bs_job'},
            }).then(res=>{ 
                this.jobData =res.result
            }) 
        },
        // 半成品明细
        getPrdList(cond){
            //获取所有产品记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'corpid', p_value:this.v_corpid,p_cond:cond ,p_table:'V_BS_bom'},
            }).then(res=>{ 
                    this.tabData =res.result
            }) 
        },
        qryPrdData(){
            let cond_=' and stfg!=\'X\''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.textparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.textparam+'\''
                }
            }
            this.getPrdList(cond_)
        },
        queryEvent(v_cond){
            let cond_= v_cond+ ' and (matty=\''+this.treeMid+'\' or matty in (select code from bs_type start with parentno=\''+this.treeMid+'\' CONNECT BY PRIOR CODE=PARENTNO))  '  
            this.getMatList(cond_)
            
        },
        //物料明细
        getMatList(cond){
            this.t_loading=true      
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'MODELNO', p_value:'MAT',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond,p_table:'V_BS_mat'},
            }).then(res=>{ 
                this.allData=res.result
                this.initPage()
                this.t_loading=false
                this.$nextTick(()=>{
                    this.$refs['refmat'].doLayout()
                })
            }) 
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allData.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allData.length < this.rowSize){
                this.rawData = this.allData          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.rawData =this.allData.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        prdPage(){
            //产品明细
            this.prdCount =this.allPrd.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allPrd.length < this.rowSize){
                this.bomData = this.allPrd          
            }else{
                if (this.v_current >1){
                    this.changePrd(this.v_current)
                }else{
                    this.bomData =this.allPrd.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
        },
        qryMatData(){
            let cond_=' and stfg!=\'X\''
            this.getMdata(cond_)
        },
        //产品树节点点击
        pMatClick(row){
            this.treePid =row.MATNO
            this.v_stfg=row.STFG
            this.dtlData=[]
            this.treeData=[]
            if (row['MATNO'].indexOf('s')>-1||row['MATNO'].indexOf('S')>-1){
                this.getData(row['MATNO'])
                this.parentno=row['MATNO']
            }
        },
        freshBom(matno){
            this.treePid =matno
            this.dtlData=[]
            this.treeData=[]
            this.getData(matno)
            this.parentno=matno 
        },
        //引入 半成品层
        jobRef(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (this.treePid.indexOf('s')>-1 ||this.treePid.indexOf('S')>-1 ){
                if(this.treeData.length>0 && checkedKeys.length==0){
                   this.promptWin=true
                    this.prompt ='请在树状BOM中选择一个节点插入' 
                }else if(this.treePid ==this.currentSelectedNode.id){
                   this.promptWin=true
                    this.prompt ='在第一层下面不能引入单层BOM' 
                }else{
                    if(this.bomty=='N'){
                        this.promptWin =true
                        this.prompt ='预制件下面不能插入，请核查'
                    }else{
                        this.prdWin =true
                        this.getPrdList('')
                    }
                }
            } else{
                this.promptWin=true
                this.prompt ='请选择树状BOM节点'
            }
        },
        //引入 树状BOM
        treeRef(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (this.treePid.indexOf('s')>-1||this.treePid.indexOf('S')>-1 ){
                if(this.treeData.length>0 && checkedKeys.length==0){
                   this.promptWin=true
                    this.prompt ='请在树状BOM中选择一个节点插入' 
                }else if(this.treePid ==this.currentSelectedNode.id){
                    this.promptWin=true
                    this.prompt ='在第一层下面不能引入树状BOM' 
                }else{
                    if(this.bomty=='N'){
                        this.promptWin =true
                        this.prompt ='预制件下面不能插入，请核查'
                    }else{
                        this.treeWin =true
                    }
                }
            } else{
                this.promptWin=true
                this.prompt ='请选择树状BOM节点'
            }
        },
        //在第一层复制树状BOM
        cpRec(row){
            getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_BS_MATBOM','').then(res=>{
                this.tarArr =res.result
                this.v_tabrow =JSON.parse(JSON.stringify(row))
                this.cpWin =true
            })
            
        },
        //变更工序
        jobUpd(){ 
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if( checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择一个节点' 
            }else {
                this.$axios({ //查询是否工序 
                    method: 'post',
                    url:this.v_manyurl+'',
                    data: {p_key:'matno',p_value:this.currentSelectedNode.id,p_key2:'parentno',p_value2:this.v_parentid,p_cond:' and idseq='+this.v_idseq+' and jobno is not null', p_table:'prd_BOMdtl' },
                }).then(res=>{
                    if (res.result.length==0 ){
                        this.promptWin=true
                        this.prompt ='只有节点为工序时才能变更'
                    }else{
                        this.jobEdit =true
                        this.getJobList('')
                    }
                })
            }
        },
        //插入工序层
        jobAdd(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择一个节点'
            }else if (this.treePid.indexOf('s')>-1 ||this.treePid.indexOf('S')>-1 ){
 
                if(this.treeData.length>0 && checkedKeys.length==0){
                   this.promptWin=true
                    this.prompt ='请在树状BOM中选择一个节点插入' 
                }else{
 
                    if(this.bomty=='N'){
                        this.promptWin =true
                        this.prompt ='预制件下面不能插入，请核查'
                    }else{
                        this.v_bool =false
                        this.jobWin =true
                        this.getJobList('')
                    }
                }
            }else{
                this.promptWin=true
                this.prompt ='请选择一产品或树状BOM节点'
            }
        },
        stfgRec(row,val){
            let v_comm=val=='Y'?'审核':'弃审'
            this.$confirm('你确定要'+v_comm+'此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                if (val=='N'){
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_table:'V_PO_REQ',p_cond:' and instr(prdno,\''+row['MATNO']+'\')>0'},
                    }).then(res=>{
                        if (res.result.length>0){
                            this.promptWin =true
                            this.prompt ='此BOM已产生订单物料需求，如需变更请前往4M变更通知界面'
                        }else{
                            let v_cond=' set stfg=\''+ val+'\',upduser=\''+this.v_usernm+'\',upddttm=\''+getDate('full')+'\''
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'PRD_BOM',p_cond:v_cond},
                            }).then(res=>{
                                this.qryBomData('')
                            })
                        }  
                    })
                }else{
                    let v_cond=' set stfg=\''+ val+'\',upduser=\''+this.v_usernm+'\',upddttm=\''+getDate('full')+'\''
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'idseq',p_value:row['IDSEQ'], p_table:'PRD_BOM',p_cond:v_cond},
                    }).then(res=>{
                        this.qryBomData('')
                    })
                }
            }).catch(err=>{})
        },
        //左边菜单
        getBomList(cond){     
            this.r_loading =true
            let v_cond=''
            if (this.v_hide =='N'){
                v_cond =' and ishide=\'N\' '
            }else {
                v_cond =' and ishide=\'Y\' '
            }
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: { p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+v_cond+' order by adddttm desc' ,p_table:'V_prd_bom'},
            }).then(res=>{ 
                if (res.code=='200') {
                    this.allPrd =res.result   
                    this.prdPage()     
                    if (res.result.length>0){
                        this.r_loading=false
                        this.treePid =res.result[0]['MATNO']
                        this.pMatClick(res.result[0])
                    } 
                    this.$nextTick(()=>{
                        this.$refs['refbom'].doLayout()
                        this.r_loading =false
                        this.$refs['refbom'].setCurrentRow(res.result[0])
                    })
                }else {
                    this.promptWin =true
                    this.prompt =res.result
                }
            }) 
        },
 
        //查询树状BOM
        getData(matno) {   
            var vm=this;
            this.loading =true
            this.$axios({
                method: 'post',
                url:'xuper_auth/getLoopData',
                data: {p_table:'V_TREE_BOM',p_cond:' and corpid=\''+this.v_corpid+'\'' ,p_value:matno}
            }).then(function(res){ 
                if (res.code==='200'){                 
                    vm.treeData =res.result 
                    if(res.result.length > 0 ){
                        vm.$nextTick(() =>{
                            //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                            vm.$refs.eltree.setCurrentKey(vm.treeid)
                            vm.loading =false   
                        })
                    }else{
                        vm.loading =false  
                    }
                } else{
                    if (res.result.indexOf('ORA-01436')>-1){
                        vm.promptWin=true
                        vm.prompt='在查询母件为：'+matno+' 的BOM层级结构中发现死循环，可能子件的层级结构含有母件产品编码，请检查'
                    }else{
                        vm.promptWin=true
                        vm.prompt=res.result
                    }
                }          
            })                            
        },
 
        //节点点击
        handleNodeClick(checkedNode, checkedInfo){
            const checkedKeys = checkedInfo.checkedKeys
            // 如果当前没有选中任何节点，直接返回
            if (checkedKeys.length === 0) {
                this.currentSelectedNode = null
                return
            }
            // 如果选中的节点数量大于1，说明触发了多选，需要强制只保留最后一个
            if (checkedKeys.length > 1) {
                // 获取当前最后被选中的节点的 key (即 checkedNode.id)
                const lastCheckedKey = checkedNode.id
                // 使用 setCheckedKeys 方法，只设置最后一个选中的 key
                // 第二个参数 leafOnly 设为 false，表示不限制只选叶子节点（如果需要只选叶子可设为 true）
                this.$refs.eltree.setCheckedKeys([lastCheckedKey])
                // 更新当前选中节点数据
                this.currentSelectedNode = checkedNode
            } else {
                // 正常单选情况
                this.currentSelectedNode = checkedNode
            }
 
            //console.log('当前单选节点:', this.currentSelectedNode);
            this.nodeLabel=checkedNode.label; 
            this.v_parentid=checkedNode.parentid           
            this.treeid =checkedNode.id
            this.bomty=checkedNode.bomty
            this.v_lvl =checkedNode.icon
            this.v_sort =checkedNode.lvl
            this.v_idseq=checkedNode.idseq
            this.getMain(checkedNode.id) 
        },
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_cond:' and idseq in (15532,16521) and lstseq in (1,2,3,4 )' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },

        getMain(v_matno){
            this.dtlData=[]            
            getTabColOrData(this.v_manyurl,'v_PRD_bom','matno',this.treePid,'corpid',this.v_corpid,'','','' ).then((res) => {   
                if (res.result.length>0){
                    this.getDtlList(res.result[0]['IDSEQ'] ,v_matno)
                }             
            })
        },
 
        // 明细 
        getDtlList(idseq,v_matno ){
            this.v_loading=true
            this.dtlData=[]
            if (this.currentSelectedNode.id==this.treePid) {
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getFreeData',
                    data: {p_cond:'select * from (SELECT LVL,MATNO,MATNM,MATTYNM,SPECNM,BOMUNITNM,QTY,POSITION,RMK,IDSEQ,LSTSEQ,BOMFLAG,ADDUSER,ADDDTTM FROM V_PRD_BOMDTL START WITH IDSEQ='+idseq+' and parentno=\''+v_matno+'\' CONNECT BY PRIOR CODE=PARENTNO ) where matno like \'m%\'' },
                }).then(res=>{ 
                    this.dtlData =res.result 
                    this.v_loading=false
                })
            }else{
               this.$axios({
                    method: 'post',
                    url:'xuper_auth/getFreeData',
                    data: {p_cond:'select * from (SELECT LVL,MATNO,MATNM,MATTYNM,SPECNM,BOMUNITNM,QTY,POSITION,RMK,IDSEQ,LSTSEQ,BOMFLAG,ADDUSER,ADDDTTM FROM V_PRD_BOMDTL START WITH IDSEQ='+idseq+' and code=\''+v_matno+'\' CONNECT BY PRIOR CODE=PARENTNO ) where matno like \'m%\'' },
                }).then(res=>{ 
                    this.dtlData =res.result 
                    this.v_loading=false
                }) 
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refdtl.doLayout()
            }) 
        },
        //净物料查询
        netMat(){ 
           this.dtlData=[]
            getTabColOrData(this.v_manyurl,'v_PRD_bom','matno',this.treePid,'corpid',this.v_corpid,'','','' ).then((res) => {   
                if (res.result.length>0){
                    let idseq =res.result[0]['IDSEQ']  
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/getFreeData',
                        data: {p_cond:'select NULL lvl,max(idseq) idseq,max(lstseq) lstseq,matno,max(matnm) matnm,max(mattynm) mattynm,max(specnm) specnm,max(BOMUNITNM) BOMUNITNM,sum(qty) qty,max(rmk) rmk,max(position) position,max(adduser) adduser,max(adddttm) adddttm from (SELECT DISTINCT LVL,MATNO,MATNM,MATTYNM,SPECNM,BOMUNITNM,QTY, RMK, IDSEQ,LSTSEQ,POSITION,ADDUSER,ADDDTTM FROM V_PRD_BOMDTL START WITH IDSEQ='
                              +idseq+' CONNECT BY PRIOR CODE=PARENTNO) where matno like \'m%\' group by matno order by matno'},
                    }).then(res=>{ 
                        this.dtlData =res.result 
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            this.$refs.refdtl.doLayout();
                        }) 
                    })
                }
            })
        },
        //删除层级
        delLvl(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择一个节点'
            }else {      
                if (this.treePid.indexOf('s')>-1 ||this.treePid.indexOf('S')>-1 ){               
                    this.$confirm('删除层级时会把此层下面所有的子层全部删除，要继续吗？','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        getTabColOrData(this.v_manyurl,'v_PRD_bom','matno',this.treePid,'corpid',this.v_corpid,'','','' ).then((res) => {   
                            let idseq_= res.result[0]['IDSEQ']
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:idseq_,p_cond:' and lstseq in (select lstseq from prd_bomdtl start with matno=\''+this.currentSelectedNode.id+'\' and idseq='+idseq_+' connect by prior matno=parentno)',p_table:'PRD_bomdtl'},
                            }).then(res=>{      
                                if(res.code =='200')  {      
                                    this.getData(this.treePid)
                                    this.dtlData =[]
                                }else{
                                    this.promptWin=true
                                    this.prompt=res.result
                                }        
                            }) 
                            //删除根节点时
                            if (this.currentSelectedNode.id==this.treePid){
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:idseq_, p_table:'PRD_bomdtl'},
                                }).then(res=>{ 
                                    if (res.code=='200'){
                                        this.$axios({
                                            method: 'post',
                                            url:'xuper_auth/delTabRec',
                                            data: {p_key:'idseq',p_value:idseq_, p_table:'PRD_bom'},
                                        }).then(res=>{ 
                                            this.treeData =[]
                                            this.qryBomData('')
                                        })
                                    } 
                                })                            
                            } 
                        })       
                    })                     
                    
                }    
            }
        },
        addTo(row){
            this.bomMth =true
            this.bomRow =row
        },
        //复制产品BOM
        cpBomPrd(){
            if (!this.treeNo){
                this.promptWin =true
                this.prompt ='请选择目标产品编码'
            }else{
                this.$confirm('确定要从源编码：'+this.v_tabrow['MATNO']+'复制到产品编码：'+this.treeNo+'吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.loadWin =true
                    let v_mainRow={MATNO:this.treeNo,'IDSEQ':'',QTY:'1',BOMTY:'16212',BOMDTTM:getDate(),VER:'1',CORPID:this.v_corpid} //默认自制
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(v_mainRow,{CORPID:this.v_corpid})), p_table:'PRD_BOM',frmid:'16532'},
                    }).then( res=>{
                        if (res.code=='200'){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/cpTreeData',
                                data: {'corpid':this.v_corpid, 'p_idseq':this.treeNo , 'code':this.v_tabrow['MATNO'],'p_user':this.v_username },
                            }).then((res)=>{ 
                                if (res.code=='200'){          
                                    this.treePid=this.v_tabrow['MATNO']
                                    this.qryBomData('') //重新刷新产品类别
                                    this.freshBom( this.v_tabrow['MATNO']) // 刷新树状BOM 
                                  
                                    this.btnEdit(false)           

                                    //this.getData(this.v_tabrow['MATNO'])   
                                    this.cpWin =false
                                    this.loadWin =false                        
                                }else{
                                    this.loadWin =false 
                                    this.promptWin =true
                                    this.prompt =res.result
                                }
                            })
                            
                        }else{
                            this.loadWin =false
                            this.prompt=res.result
                            this.promptWin =true
                        }
                    })
                    
                }).catch(()=>{})
            }
        },
        //添加树状BOM
        treePrd(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择一个节点'
            }else if (this.treePid ==this.treeNo){
                this.promptWin =true
                this.prompt ='不能引用自身，请核查'
            }else{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/refTreeNo',
                    data: {'corpid':this.v_corpid, 'p_idseq':this.treePid, 'gpno':this.currentSelectedNode.id ,'code':this.treeNo,'p_user':this.v_username },
                }).then((res)=>{ 
                    if (res.code=='200'){
                        this.getData(this.treePid)
                        this.treeWin =false
                    }else{
                        this.promptWin =true
                        this.prompt =res.result
                    }
                })
 
            }
        },
        // 添加单层BOM
        addPrd(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择一个节点'
            }else{
                let v_parent =this.treeData.length==0?this.treePid:this.currentSelectedNode.id
                let v_level='',v_sublvl=''
                getTabColOrData(this.v_manyurl,'v_PRD_bom','matno',this.treePid,'corpid',this.v_corpid,'','','' ).then((res) => {   
                    let idseq_= res.result[0]['IDSEQ']
                    let v_single= 'G'+jsuuid() // 由于不能使用单层BOM的物料编码，生成一个唯一码
                    let v_topRow={MATNO:v_single,PARENTNO:v_parent ,'IDSEQ':idseq_ ,QTY:this.v_qty,BOMTY:'17447',BOMDTTM:getDate(),BOMNO:this.bomRow['IDNO'] ,BOMFLAG:this.impFlag,LVL:this.v_lvl }  
                    //1、顶层物料
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(Object.assign(v_topRow,{'LSTSEQ':''})), p_table:'prd_BOMDTL',p_idseq:idseq_},
                    }).then(res=>{
                        if (res.code=='200') {
                            v_level =res.idseq
                            //2. 单层bom 的所有工序
                            this.$axios({
                                method: 'post',
                                url:this.v_manyurl ,
                                data: {p_key:'corpid',p_value:this.v_corpid,p_key2:'idseq',p_value2:this.bomRow['IDSEQ'] , p_table:'V_BS_BOMjob',p_cond:' order by jobnum,adddttm' },
                            }).then(async (res)=>{ 
                                for (let k=0 ;k<res.result.length; k++){
                                    // 1、先在选中节点下添加所有工序
                                    let v_jobrow =res.result[k]
                                    let v_lstseq =res.result[k]['LSTSEQ']
                                    let v_matno= jsuuid() // 由于不能使用工序的编码，生成一个唯一码
                                    let v_mainRow={LVL:v_level,MATNO:v_matno,PARENTNO:v_single ,'IDSEQ':idseq_ ,QTY: this.v_qty,BOMTY:'16293',BOMDTTM:getDate(),JOBNO:v_jobrow['JOBNO'],REFIDSEQ:v_jobrow['IDSEQ'],REFLSTSEQ:v_jobrow['LSTSEQ'],REFIDTY:'JOB'} //默认自制
                                    await this.$axios({
                                        method: 'post',
                                        url:'xuper_auth/tableBodySave',
                                        data: {p_json:JSON.stringify(Object.assign(v_mainRow,{'LSTSEQ':''})), p_table:'prd_BOMDTL',p_idseq:idseq_},
                                    }).then(async (res)=>{ 
                                        v_sublvl =res.idseq
                                        // 2、在工序下添加所有的物料
                                        if (res.code=='200'){
                                            await this.$axios({
                                                method: 'post',
                                                url:this.v_manyurl ,
                                                data: {p_key:'corpid',p_value:this.v_corpid,p_key2:'idseq',p_value2:this.bomRow['IDSEQ'],p_key3:'lstseq',p_value3:v_lstseq , p_table:'V_BS_BOMdtl' },
                                            }).then(async (res)=>{ 
                                                const promises = res.result.map(item=>{
                                                    let qty_ =item['QTY'] * this.v_qty
                                                    let v_subRow={REFIDSEQ:item['IDSEQ'],REFLSTSEQ:item['LSTSEQ'],REFITMSEQ:item['ITMSEQ'],REFIDTY:'MAT',LVL:v_sublvl,MATNO:item['MATNO'],PARENTNO:v_matno,BOMFLAG:this.impFlag ,'IDSEQ':idseq_ ,QTY: qty_,BOMTY:'',BOMDTTM:getDate(),POSITION:item['POSITION'] ,RMK:item['RMK']} //默认自制
                                                    return this.$axios({
                                                        method: 'post',
                                                        url:'xuper_auth/tableBodySave',
                                                        data: {p_json:JSON.stringify(Object.assign(v_subRow,{'LSTSEQ':''})), p_table:'prd_BOMDTL',p_idseq:idseq_},
                                                    })
                                                })
                                                //等待所有请求完成
                                                Promise.all(promises).then(()=>{
                                                    this.getData(this.treePid)
                                                })
                                            
                                            })
                                        }else{
                                            this.promptWin=true
                                            this.prompt=res.result
                                        }
                                        
                                    })                            
                                }
                                this.getData(this.treePid)
                            })
                        }else{
                            if (res.result.indexOf('ORA-00001')>-1){
                                this.prompt='此节点下已存在此单层BOM，请核查'
                            }else{
                                this.prompt=res.result
                            }
                            this.promptWin =true
                        }
                    })
                })
                this.prdWin =false
                this.bomMth=false
            }
        },
        //修改工序
        modJob(){
            if (! this.v_jobno2){
                this.promptWin=true
                this.prompt ='请选择工序'
            }else{
                this.$confirm('你确定要变更此工序吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/updateRec',
                        data: {p_key:'matno',p_value:this.currentSelectedNode.id,p_key2:'parentno',p_value2:this.v_parentid,p_key3:'idseq',p_value3:this.v_idseq,p_table:'PRD_BOMDTL',p_cond:' set jobno=\''+ this.v_jobno2+'\''},
                    }).then(res=>{
                        this.jobEdit=false
                        this.getData(this.treePid)
                    })
                }).catch(err=>{})
            }
        },
        //新增 工序 到BOM
        addJob(){ 
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (checkedKeys.length==0){
                this.promptWin=true
                this.prompt ='请选择一个节点'
            }else if(this.bomty=='N'){
                this.promptWin =true
                this.prompt ='预制件下面不能插入，请核查'
            }else{
                if (! this.v_jobno){
                    this.promptWin=true
                    this.prompt ='请选择工序'
                }else{ 
                    this.v_bool =true
                    let  bomty ='JOB'  //工序
                    let v_pid =(this.currentSelectedNode.id.indexOf('s')>-1 ||this.currentSelectedNode.id.indexOf('S')>-1)?this.currentSelectedNode.id:this.treePid
                    let v_parent =this.treeData.length==0?v_pid:this.currentSelectedNode.id
                    let v_matno=parseInt(new Date().getTime())// 由于不能使用工序的编码，生成一个时间唯一码
                    this.$axios({ //查询母件的IDSEQ
                        method: 'post',
                        url:this.v_manyurl ,
                        data: {p_key:'corpid',p_value:this.v_corpid,p_key2:'matno',p_value2:this.treePid, p_table:'prd_BOM' },
                    }).then(res=>{
                        let idseq_ =res.result[0]['IDSEQ']
                        let v_mainRow={MATNO:v_matno,PARENTNO:v_parent ,'IDSEQ':idseq_ ,QTY:'1',BOMTY:bomty,BOMDTTM:getDate(),JOBNO: this.v_jobno,LVL:this.v_lvl,JOBNUM:this.v_jobnum } //默认自制
                        //console.log('v_level:'+this.v_lvl,idseq_,v_parent)
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/tableBodySave',
                            data: {p_json:JSON.stringify(Object.assign(v_mainRow,{'LSTSEQ':''})), p_table:'prd_BOMDTL',p_idseq:idseq_},
                        }).then(res=>{ 
                            if (res.code=='200'){
                                this.getData(this.treePid)
                            }else{
                                this.promptWin =true
                                this.prompt =res.result
                            }
                        })                            
                    })                   
                    this.jobWin=false              
                }
            }
        },
        //新增物料到BOM
        addBom(){
            const checkedKeys = this.$refs.eltree.getCheckedKeys()
            if (this.treePid.indexOf('s')>-1 ||this.treePid.indexOf('S')>-1  ){
                if(checkedKeys.length==0){  
                   this.promptWin=true
                    this.prompt ='请在树状BOM中选择一个节点插入' 
                }else if(this.treePid==this.currentSelectedNode.id){  
                   this.promptWin=true
                    this.prompt ='在第一层下面不能插入物料' 
                }else{
                    let selArr =[]
                    for (let k=0 ;k<this.rawData.length; k++){
                        if(this.rawData[k]['SEL']=='Y'){
                            selArr.push({'MATNO':this.rawData[k]['IDNO'],'QTY':this.rawData[k]['QTY']})
                        }
                    }
                    if (selArr.length==0){
                        this.promptWin =true
                        this.prompt ='请选择记录'
                    }
                    else{
                        this.matSave(selArr ) 
                    }
                }
            } else{
                this.promptWin=true
                this.prompt ='请选择一产品或树状BOM节点'
            }          
        },
 
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ 
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(vm.v_manyurl,'v_sys_form_fld','idseq','16532','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        // label: res.result[k].title,
                        sortable: res.result[k].SORTABLE,
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16532','lstseq','3','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        edcss:res.result[k].EDCSS,
                    })
                }
            })
            getTabColOrData(vm.v_manyurl,'v_sys_form_fld','idseq','16532','lstseq','7','','',' order by sortby').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.bomArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16532','lstseq','6','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.matArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16521','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    if (res.result[k].key!=='STFG')
                    vm.jobArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','5','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.matCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        edcss:res.result[k].EDCSS,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .ok_css{
        color:rgb(168, 9, 31);
        font-size:12px;
    }
    .notok_css{
        color:#606266;
        font-size:12px;
    }
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
  <style lang ="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        padding-right: 8px;
    }
    .el-table .warning-row {
        /* background: oldlace; */
        color:rgb(247, 145, 145);
    }
    .el-table {
        th{
            padding:0px;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 2px ;
            font-size:11px;
        }   
    }
 </style>